export const showConstants = {
    GET_ALL_SHOW_ACTION_REQUEST: 'GET_ALL_SHOW_ACTION_REQUEST',
    GET_ALL_SHOW_ACTION_SUCCESS: 'GET_ALL_SHOW_ACTION_SUCCESS',
    GET_ALL_SHOW_ACTION_FAILURE: 'GET_ALL_SHOW_ACTION_FAILURE',

    GET_SHOW_DETAILS_ACTION_REQUEST: 'GET_SHOW_DETAILS_ACTION_REQUEST',
    GET_SHOW_DETAILS_ACTION_SUCCESS: 'GET_SHOW_DETAILS_ACTION_SUCCESS',
    GET_SHOW_DETAILS_ACTION_FAILURE: 'GET_SHOW_DETAILS_ACTION_FAILURE'
}